import React from 'react'

function Introduction({
  srcLogo,
  altLogo,
  description,
  backgroundColor,
  color,
  img,
  srcProduct,
  altProduct,
  id,
  imgNoAnimation,
  srcImgNoAnimation,
  altImgNoAnimation,
}) {
  return (
    <div
      id={id}
      className="padding-100 flex-center flex__gap-50"
      style={{ background: backgroundColor }}
    >
      <div
        className="flex-center flex-column flex__gap-50 width-70"
        data-aos="fade-right"
      >
        <div className="introduction__img-logo">
          <img src={srcLogo} alt={altLogo} />
        </div>
        <p className="introduction__content text-center" style={{ color }}>
          {description}
        </p>
      </div>
      {img && (
        <div className="half-screen flex-center">
          <div className="introduction__img-product">
            <img src={srcProduct} alt={altProduct} />
          </div>
        </div>
      )}
      {imgNoAnimation && (
        <div className="img img-450">
          <img src={srcImgNoAnimation} alt={altImgNoAnimation} />
        </div>
      )}
    </div>
  )
}

export default Introduction
